<template>
  <v-app-bar app flat color="white" class="px-4 topbar-border">
    <div class="d-flex align-end mr-4">
      <img :src="logoSrc" alt="Hublot" height="38" />
    </div>
    <v-spacer />
    <template v-if="contactsLoading">
      <span class="contacts-label mr-2">Contacts</span>
      <v-skeleton-loader v-for="n in 2" :key="'skel-' + n" type="chip" class="mr-2" />
      <v-divider vertical class="mx-3" />
    </template>
    <template v-else-if="inscriptionContacts.length > 0">
      <span class="contacts-label mr-2">Contacts</span>
      <v-tooltip bottom v-for="contact in inscriptionContacts" :key="contact.id">
        <template #activator="{ on }">
          <v-chip v-on="on" small outlined color="primary" class="mr-2">
            <v-icon left x-small>person</v-icon>
            {{ contact.fullName }}
          </v-chip>
        </template>
        <div>
          <div class="font-weight-bold">{{ contact.fullName }}</div>
          <div>{{ contact.function }}</div>
          <div>{{ contact.email }}</div>
          <div v-if="contact.mobile">{{ contact.mobile }}</div>
        </div>
      </v-tooltip>
      <v-divider vertical class="mx-3" />
    </template>
    <v-chip color="primary" dark class="font-weight-bold mr-4 px-4" label>
      <v-icon left small>assignment</v-icon>
      Inscription
    </v-chip>
    <v-btn
      v-if="!errorCode && enrollId"
      color="primary"
      outlined
      :disabled="isSaving"
      :loading="isSaving"
      @click="$emit('save')"
      :class="['save-btn', { 'save-btn--dirty': isDirty && !isSaving }]"
    >
      <v-icon left small>save</v-icon>
      Enregistrer
    </v-btn>
  </v-app-bar>
</template>

<script>
const LOGOS = {
  boucherie: require('@/assets/long-boucherie.png'),
  poissonnerie: require('@/assets/logo_poissonnerie.png'),
}

export default {
  name: 'HeaderBar',
  props: {
    contactsLoading: { type: Boolean, default: false },
    inscriptionContacts: { type: Array, default: () => [] },
    errorCode: { type: Boolean, default: false },
    enrollId: { type: [Number, String], default: null },
    invalidContact: { type: Boolean, default: false },
    metier: { type: Object, default: () => ({}) },
    isSaving: { type: Boolean, default: false },
    isDirty: { type: Boolean, default: false },
  },
  computed: {
    logoSrc () {
      return LOGOS[this.metier.key] || LOGOS.poissonnerie
    },
  },
}
</script>

<style scoped lang="scss">
@import '@/assets/vars.scss';

.topbar-border {
  border-bottom: 2px solid var(--v-secondary-base) !important;
}
.save-btn {
  font-weight: 600;
  letter-spacing: 0.04em;

  &--dirty {
    animation: pulse-save 1.6s ease-in-out infinite;
  }
}

@keyframes pulse-save {
  0%, 100% { box-shadow: 0 0 0 0 transparent; }
  50% { box-shadow: 0 0 0 5px color-mix(in srgb, var(--v-primary-base) 35%, transparent); }
}
.contacts-label {
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: rgba(0, 0, 0, 0.4);
}
</style>
